import { FC } from 'react'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '_metronic/helpers'

const Error404View: FC = () => {
	return (
		<div
			className="d-flex flex-column flex-root position-absolute bg-kumopack-primary-600"
			style={{ zIndex: 9999, width: '100vw', height: '100vh' }}>
			<div className="d-flex flex-column flex-center flex-column-fluid p-10">
				{/* begin::Illustration */}
				<img
					src={toAbsoluteUrl('/media/illustrations/sketchy-1/18.png')}
					alt=""
					className="mw-100 mb-10 h-lg-450px"
				/>
				{/* end::Illustration */}
				{/* begin::Message */}
				<h1 className="fw-bold mb-10 text-kumopack-base-white">Seems there is nothing here</h1>
				{/* end::Message */}
				{/* begin::Link */}
				<Link to="/" className="btn btn-kumopack-primary-700 text-kumopack-base-white">
					Return Home
				</Link>
				{/* end::Link */}
			</div>
		</div>
	)
}

export default Error404View
